import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import BaseImage from '@learningblocks/exp-constants/lib/Images/mc_frontview_base.svg';
import MCFrontView from '@learningblocks/exp-constants/lib/Images/mc_frontview.svg';
import {Settings} from './Settings';
import {WarningBlock} from './WarningBlock';
import {InstructionBlock} from './InstructionBlock';
import {Heading} from './Heading';
import {InstructionContent} from './InstructionContent';
import {WarningContainer} from './WarningContainer';
import {EmptyBlock} from './EmptyBlock';
import {Wrapper} from '../../Wrapper';

import './style.scss';

/**
 *  FrontViewContent:
 *    to render the contents (settings and display) for front view of microcentrfige Modal view
 */
export function FrontViewContent(props) {
  return (
    <Wrapper className='mc_frontview'>
      <InstructionBlock className='mc_frontview_instruction'>
        <Heading className='mc_frontview_instruction_header' />
        <InstructionContent className='mc_frontview_instruction_text' />
        <WarningContainer>
          <WarningBlock />
        </WarningContainer>
        <EmptyBlock className='mc_frontview_instruction_emptyArea' />
      </InstructionBlock>
      <Image className='mc_frontview_equipment' src={MCFrontView} />
      <Wrapper className='mc_frontview_settingsBlock'>
        <Settings
          data={props.data.settings}
          setRPM={props.setRPM}
          setTimer={props.setTimer}
          onRunCentrifuge={props.onRunCentrifuge}
          onStopCentrifuge={props.onStopCentrifuge}
        />
      </Wrapper>
      <Image className='mc_frontview_baseImage' src={BaseImage} />
    </Wrapper>
  );
}

FrontViewContent.propTypes = {
  /**
   * data for settings block
   */
  data: PropTypes.shape({
    settings: PropTypes.shape({
      /**
       * value for rpm block
       */
      rpmValue: PropTypes.number,
      /**
       * value for timer block
       */
      timerValue: PropTypes.instanceOf(Date),
    }),
  }),
  /**
   * callback function to run centrifuge
   */
  onRunCentrifuge: PropTypes.func,
  /**
   * callback function to stop centrifuge
   */
  onStopCentrifuge: PropTypes.func,
  /**
   * callback function to set rpm value
   */
  setRPM: PropTypes.func,
  /**
   * callback function to set timer value
   */
  setTimer: PropTypes.func,
};

FrontViewContent.defaultProps = {};
